import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Home.css';
import getActiveCategories from './getActiveCategories.graphql'
import getSiteSettings from './getSiteSettings.graphql'
import getAllHomePageSettings from './getAllHomePageSettings.graphql'

//Components
import HomeSection from '../../components/Home/HomeSection/HomeSection';
import CitySection from '../../components/Home/CitySection/CitySection';
import SafetyGrid from '../../components/Home/SafetyGrid/SafetyGrid';
import AboutGrid from '../../components/Home/AboutGrid/AboutGrid';
import SignupGrid from '../../components/Home/SignupGrid/SignupGrid';
import { HomeProvider } from '../context/homeContext'
import FooterImageSection from '../../components/Home/FooterImageSection/FooterImageSection';
import LandingPage from './LandingPage';

class Home extends React.Component {

  render() {
    const { getSiteSettings: { loading }, getAllHomePageSettings: { loading: homeLoading } } = this.props

    return (
      <div>
        {!loading && !homeLoading && <LandingPage />}
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  graphql(getActiveCategories, {
    name: 'getCategories',
    options: {
      ssr: true,
      //fetchPolicy: 'network-only'
    }
  }),
  graphql(getSiteSettings, {
    name: 'getSiteSettings',
    options: {
      variables: {
        type: 'site_settings',
      },
      ssr: true
    }
  }),
  graphql(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: true
    }
  })
)(Home);
